module.exports = __webpack_public_path__ + "img/appointment-instructions-example.635d2176.png";